import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'

const helpCenter: RouteRecordRaw = {
  path: '/help-center',
  name: 'HelpCenter',
  component: Layout,
  redirect: '/help-center/index',
  meta: {
    title: '帮助中心'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/HelpCenter/index.vue'),
      meta: {
        title: '帮助中心',
        hideInMenu: true,
        // 仅返回上一页
        onlyBack: true
      }
    }
  ]
}

export default helpCenter
